<template lang="pug">
  .search-result(
    :style="style"
    :data-id="id"
    :class="{ visible }"
  )
    .search-result__arrow(
      v-show="expanded"
    )
    .search-result__image-wrapper(
      v-observe-visibility="{ callback: visibilityChanged, once: true, throttle: 300 }"
      @click="($emit('click', $event))"
      :style="{ paddingTop, background: loading ? primaryColor : null }"
    )
      img.search-result__image(
        :src="thumbnail.url"
        @load="onImageLoad"
      )
      .search-result__shade
      .search-result__dimensions.search-result__overlay
        | {{ image.dimensions.width }} x {{ image.dimensions.height }}
    .search-result__info
      .search-result__info__title(
        v-html="title"
      )
      .search-result__info__display-link {{ displayLink || hostname }}
</template>

<script>
import content from '@/content'

export default {
  props: {
    id: String,
    workId: String,
    image: {
      type: Object,
      default: () => ({
        dimensions: {}
      })
    },
    thumbnail: {
      type: Object,
      default: () => ({
        dimensions: {}
      })
    },
    primaryColor: String,
    title: String,
    displayLink: String,
    scale: {
      type: Array,
      default: () => [0, '%']
    },
    expanded: Boolean,
    layout: String
  },

  data() {
    return {
      thumbnailUrl: null,
      loading: true,
      visible: false
    }
  },

  computed: {
    style() {
      let style
      if (this.layout === 'grid') {
        const ratio = this.ratios.widthHeight
        const [factor, unit] = this.scale
        style = {
          width: ratio * factor + unit,
          'flex-grow': ratio
        }
      } else {
        style = {
          display: 'table',
          'table-layout': 'fixed'
        }
      }

      return style
    },

    paddingTop() {
      return this.ratios.heightWidth * 100 + '%'
    },

    ratios() {
      const { width, height } = this.image.dimensions
      return {
        widthHeight: width / height,
        heightWidth: height / width
      }
    },

    hostname() {
      return location.hostname
    }
  },

  created() {
    // this.loadThumbnail()
  },

  methods: {
    visibilityChanged(isVisible) {
      if (isVisible) {
        this.loadThumbnail()
      }
    },

    async loadThumbnail() {
      this.loading = true
      if (!this.thumbnail.url) {
        const { workId, id: resultId } = this
        const { url } = await content.get('thumbnail', {
          params: { workId, resultId }
        })
        this.$set(this.thumbnail, 'url', url)
      }
    },

    onImageLoad() {
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
@import '~@/settings';

.search-result.visible .search-result__image-wrapper {
  background-color: red !important;
  transition: background-color 1s linear;
}

#app.hasHover {
  .search-result {
    img:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.35);
    }

    .search-result__image-wrapper:hover .search-result__overlay {
      display: block;
    }
  }
}
.search-result {
  // margin-right: 1rem;
  // margin-bottom: 1rem;
  position: relative;
  font-size: map-get($font-size, small);

  // ellipsis and width workaround (https://stackoverflow.com/a/29947766)
  // display: table;
  // table-layout: fixed;

  &__arrow {
    border-bottom: 10px solid #{map-get($bg-color, dark)};
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    height: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -1rem;
    width: 0;
  }

  img {
    position: absolute;
    top: 0;
    width: 100%;
  }

  &__shade {
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.03);
  }

  &__image-wrapper {
    position: relative;
    cursor: pointer;
  }

  &__overlay {
    position: absolute;
    display: none;
    padding: 2px 4px;
    color: white;
    background: rgba(51, 51, 51, 0.8);
  }

  &__dimensions {
    width: 100%;
    bottom: 0;
    left: 0;
  }

  &__info {
    padding: 6px 4px 4px;

    > * {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__title {
      color: map-get($color, medium);
    }

    &__display-link {
      color: map-get($color, light);
    }
  }
}
</style>
